<template>
  <div class="tab">
    <img class="tab-back" src="../assets/tab-bottom.png" alt="" />
    <div class="tab-block">
      <div class="tab-block-left">
        <img class="tab-block-left-logo" src="../assets/tab-logo.png" />
        <div class="tab-block-left-phone">400-609-8779</div>
        <div class="tab-block-left-adress">
          深圳市龙岗区平湖街道禾花社区平吉大道321号A栋313
        </div>
      </div>
      <img class="tab-block-right" src="../assets/tab-qrcode.png" />
    </div>

    <div class="tab-bottom">
      <div class="tab-bottom-div">
        <div class="tab-bottom-div-title">Copyright©2019汇智启航科技</div>
        <div class="tab-bottom-div-text">
          All rights reserved.ICP许可证号<span @click="yueStop"
            >粤ICP备2025375199号</span
          >
          <!-- ,<span @click="yueStop">粤ICP备2025375199号-2</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    yueStop() {
      window.open(
        "https://beian.miit.gov.cn/#/Integrated/index",
        "_black"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.tab {
  width: 100%;
  height: 247.5px;
  position: relative;
  .tab-back {
    position: absolute;
    width: 100%;
    height: 247.5px;
    object-fit: fill;
  }
  .tab-block {
    padding-top: 34.5px;
    box-sizing: border-box;
    display: flex;
    margin: 0 20px;
    justify-content: space-between;
    position: relative;
    .tab-block-left {
      width: 180px;
      .tab-block-left-logo {
        width: 120px;
        height: 30.3px;
      }
      .tab-block-left-phone {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 15px;
        margin-top: 26px;
        margin-bottom: 13px;
      }
      .tab-block-left-adress {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.7;
      }
    }
    .tab-block-right {
      width: 127px;
      height: 127px;
    }
  }

  .tab-bottom {
    position: absolute;
    bottom: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .tab-bottom-div {
      text-align: center;
      .tab-bottom-div-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 16.5px;
        opacity: 0.7;
        letter-spacing: 1px;
      }
      .tab-bottom-div-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.7;
        letter-spacing: 0.1px;

        span {
          text-decoration: underline;

        }
      }
    }
  }
}
</style>